import {Partner} from './partner/partner';
import {Chat} from './chat';

export interface Document {
  id: number;
  name: string;
  fileName?: string;
  fileExtension?: string;
  fileSize: string;
  ownerId: number;
  partnerId: number;
  type: string;
  url: string;
  validationStatus: 'NonValidated' | 'ValidationPending' | 'Validated';
  expirationDate: string;
  documentValidations?: DocumentValidation[];
  documentTypeId: number;
  documentType?: DocumentType;

  validationDate?: string;
  correctionDate?: string;
  rejectionDate?: string;
  rejectionReason?: string;
  owner?: Partner;
  partner?: Partner;
  chatId: number;
  chat?: Chat;
  file?: string;
  isDeleted?: boolean;
  equipmentId?: number;
}

export interface DocumentCreate {
  name: string;
  ownerId: number;
  partnerId: number;
  documentTypeId: number;
  expirationDate: string;
  type: string;
  file: string;
}

export interface DocumentLinkCreate {
  documentId: number;
  innerLinkDocumentPayload: { entityId: number; isLinked: boolean };
  entityType: EntityType;
}

export type EntityType =
  | 'Project'
  | 'Service'
  | 'Equipment'
  | 'Event'
  | 'ServiceGood'
  | 'ServiceOrder'
  | 'Location'
  | 'Partner'
  | 'Lead';

export interface DocumentValidation {
  id: number;
  documentId: number;
  partnerId: number;
  reason: string;
  createdOn: string;
  partnerValidator?: Partner;
}

export interface DocumentValidationCreate {
  documentId: number;
  partnerId: number;
  reason?: string;
  validationStatus: string;
}

export interface DocumentType {
  id: number;
  name: string;
}

